module.exports = __webpack_public_path__ + "static/media/icon_error_exclamation.f66e90bd.svg";